import { Alert, Container } from '@mui/material';
import { useGeneralDelDia } from './hooks/useGeneralDelDia';
import HeaderDia from './components/HeaderDia';
import AccionesDia from './components/AccionesDia';
import ResumenDia from './components/ResumenDia';
import TablaTransacciones from './components/TablaTransacciones';
import ModalFondosExternos from './components/ModalFondosExternos';
import {
  ModalMovimientos,
  ModalGastos,
  ModalAjustes,
  ModalTraspasCaja,
  ModalArqueoCaja,
  ModalLimpieza,
} from './ModalesInventario';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Button, Typography, Chip, Stack } from '@mui/material';

export default function GeneralDelDia({ state, gastosState, limpiezasState, onConvertirALimpieza, onCorregir, onHistorialCorrecciones }) {
  const {
    fechaSeleccionada, setFechaSeleccionada, fechaDelDiaFormato,
    modales,
    tipoMov, subTipo,
    filaActual, setFilaActual,
    carrito,
    gasto, setGasto,
    tipoAjuste, setTipoAjuste,
    montoAjuste, setMontoAjuste,
    descripcionAjuste, setDescripcionAjuste,
    montoTraspaso, setMontoTraspaso,
    direccionTraspaso, setDireccionTraspaso,
    tipoFondo, setTipoFondo,
    montoFondo, setMontoFondo,
    descripcionFondo, setDescripcionFondo,
    metodoPagoFondos, setMetodoPagoFondos,
    díaBloqueado,
    transacciones, totalEfectivo, totalQR, datosDelDia, inicioEfectivo, inicioQR,
    transaccionEnEdicion, valoresEdicion,
    iniciarEdicion, cancelarEdicion, guardarEdicion,
    handleCambioMovimiento, cambiarValorEdicion,
    handleAnularTransaccion, handleEditarFecha,
    handleAbrirMovimientos, handleAbrirVenta,
    handleAgregarAlCarrito, handleEliminarDelCarrito, handleRegistrarMovimientos,
    handleAbrirGasto, handleRegistrarGasto,
    handleAbrirAjuste, handleRegistrarAjuste,
    handleAbrirTraspaso,
    handleRegistrarArqueo, handleRegistrarAjustePorArqueo, handleAnularArqueo,
    handleAbrirFondos, handleRegistrarFondos,
    handleAbrirLimpieza,
  } = useGeneralDelDia(state, gastosState);

  const limpiezasDia = (limpiezasState?.limpiezas || []).filter(l => new Date(l.fecha).toLocaleDateString('en-CA', { timeZone: 'America/La_Paz' }) === new Date(fechaSeleccionada + 'T12:00:00-04:00').toLocaleDateString('en-CA', { timeZone: 'America/La_Paz' }));

  return (
    <Container maxWidth={false} disableGutters sx={{ py: 4, width: '100%' }}>
      {díaBloqueado && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          🔒 El día está bloqueado por un arqueo completado. Las transacciones están deshabilitadas.
        </Alert>
      )}

      {onHistorialCorrecciones && <Button sx={{ mb: 2 }} variant="outlined" onClick={() => onHistorialCorrecciones()}>Historial de correcciones y restauraciones</Button>}
      <HeaderDia fecha={fechaSeleccionada} onChange={setFechaSeleccionada} />

      <AccionesDia
        onCompra={() => handleAbrirMovimientos('ENTRADA')}
        onVenta={handleAbrirVenta}
        onSalida={() => handleAbrirMovimientos('SALIDA')}
        onGasto={handleAbrirGasto}
        onAjuste={handleAbrirAjuste}
        onTraspaso={handleAbrirTraspaso}
        onFondos={handleAbrirFondos}
        onLimpieza={handleAbrirLimpieza}
        díaBloqueado={díaBloqueado}
      />

      <ResumenDia
        efectivo={totalEfectivo}
        qr={totalQR}
        datos={datosDelDia}
        inicioEfectivo={inicioEfectivo}
        inicioQR={inicioQR}
        fechaFormato={fechaDelDiaFormato}
        díaBloqueado={díaBloqueado}
        onArqueo={() => modales.abrir('ARQUEO')}
      />

      {limpiezasDia.length > 0 && (
        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>🧹 Limpiezas del día</Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Origen</TableCell>
                <TableCell>Trabajador</TableCell>
                <TableCell align="right">Total compra</TableCell>
                <TableCell align="center">Acción</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {limpiezasDia.map(l => (
                <TableRow key={l.id || l._id} sx={l.estado === 'ANULADO' ? { opacity: 0.6, textDecoration: 'line-through' } : {}}>
                  <TableCell>
                    {state.productos.find(p => p.id === l.materialOrigenId || p.id === l.materialOrigenId?.toString())?.nombre || '—'}
                    {' '}({l.cantidadDescontadaKg} kg)
                  </TableCell>
                  <TableCell>
                    <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap">
                      <span>{l.trabajadorDescripcion || '—'}</span>
                      {l.estado === 'ANULADO' && <Chip label="ANULADO" size="small" />}
                      {l.convertidoATipo && <Chip label={'Convertido a ' + l.convertidoATipo} size="small" />}
                      {l.pendingSync && (
                        <Chip label="Pendiente sync" size="small" color="warning" variant="outlined" />
                      )}
                    </Stack>
                  </TableCell>
                  <TableCell align="right">Bs {Number(l.importeTotalCompra).toFixed(2)}</TableCell>
                  <TableCell align="center">
                    <Stack direction="row" spacing={0.5} flexWrap="wrap" justifyContent="center" useFlexGap>
                      {l.estado !== 'ANULADO' && onCorregir && (
                        <>
                          <Button
                            size="small"
                            variant="outlined"
                            disabled={díaBloqueado || l.pendingSync}
                            onClick={() => onCorregir({ tipo: 'LIMPIEZA', objOriginal: l }, 'EDITAR')}
                          >
                            Editar
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            disabled={díaBloqueado || l.pendingSync}
                            onClick={() => onCorregir({ tipo: 'LIMPIEZA', objOriginal: l })}
                          >
                            Convertir
                          </Button>
                          <Button
                            size="small"
                            color="error"
                            disabled={díaBloqueado || l.pendingSync}
                            onClick={() => onCorregir({ tipo: 'LIMPIEZA', objOriginal: l }, 'ANULAR')}
                          >
                            Anular
                          </Button>
                        </>
                      )}
                      {l.estado !== 'ANULADO' && !onCorregir && (
                        <Button
                          size="small"
                          color="error"
                          disabled={díaBloqueado}
                          onClick={async () => {
                            if (!window.confirm('¿Anular esta limpieza completa?')) return;
                            await limpiezasState.anularLimpieza(l.id || l._id);
                          }}
                        >
                          Anular
                        </Button>
                      )}
                      {l.reemplazadoPorCorreccionId && onHistorialCorrecciones && (
                        <Button size="small" onClick={() => onHistorialCorrecciones(l.reemplazadoPorCorreccionId)}>
                          Ver cambio
                        </Button>
                      )}
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}

      <TablaTransacciones
        transacciones={transacciones}
        fechaFormato={fechaDelDiaFormato}
        transaccionEnEdicion={transaccionEnEdicion}
        valoresEdicion={valoresEdicion}
        onIniciarEdicion={iniciarEdicion}
        onCancelarEdicion={cancelarEdicion}
        onGuardarEdicion={guardarEdicion}
        onCambioMovimiento={handleCambioMovimiento}
        cambiarValorEdicion={cambiarValorEdicion}
        onAnular={handleAnularTransaccion}
        onEditarFecha={handleEditarFecha}
        onCorregir={onCorregir}
        onHistorial={onHistorialCorrecciones}
        onConvertirGastoALimpieza={onConvertirALimpieza}
        diaBloqueado={díaBloqueado}
      />

      {/* ── Modales ── */}
      <ModalMovimientos
        open={modales.esAbierto('MOVIMIENTO')}
        onClose={modales.cerrar}
        tipo={tipoMov}
        subTipo={subTipo}
        fechaSeleccionada={fechaSeleccionada}
        state={state}
        productos={state.productos}
        díaBloqueado={díaBloqueado}
        filaActual={filaActual}
        setFilaActual={setFilaActual}
        carrito={carrito}
        onAgregarAlCarrito={handleAgregarAlCarrito}
        onEliminarDelCarrito={handleEliminarDelCarrito}
        onRegistrar={handleRegistrarMovimientos}
      />

      <ModalLimpieza
        open={modales.esAbierto('LIMPIEZA')}
        onClose={modales.cerrar}
        mode="create"
        productos={state.productos}
        fechaSeleccionada={fechaSeleccionada}
        díaBloqueado={díaBloqueado}
        calcularStock={state.calcularStock}
        onCrear={limpiezasState?.crearLimpieza}
      />

      <ModalGastos
        open={modales.esAbierto('GASTO')}
        onClose={modales.cerrar}
        fechaSeleccionada={fechaSeleccionada}
        gasto={gasto}
        setGasto={setGasto}
        categorias={gastosState.categorias}
        gastosState={gastosState}
        onRegistrar={handleRegistrarGasto}
        díaBloqueado={díaBloqueado}
      />

      <ModalAjustes
        open={modales.esAbierto('AJUSTE')}
        onClose={modales.cerrar}
        state={state}
        fechaSeleccionada={fechaSeleccionada}
        tipo={tipoAjuste}
        setTipo={setTipoAjuste}
        monto={montoAjuste}
        setMonto={setMontoAjuste}
        descripcion={descripcionAjuste}
        setDescripcion={setDescripcionAjuste}
        onRegistrar={handleRegistrarAjuste}
        díaBloqueado={díaBloqueado}
      />

      <ModalTraspasCaja
        open={modales.esAbierto('TRASPASO')}
        onClose={modales.cerrar}
        state={state}
        fechaSeleccionada={fechaSeleccionada}
        díaBloqueado={díaBloqueado}
        monto={montoTraspaso}
        setMonto={setMontoTraspaso}
        direccion={direccionTraspaso}
        setDireccion={setDireccionTraspaso}
      />

      <ModalArqueoCaja
        open={modales.esAbierto('ARQUEO')}
        onClose={modales.cerrar}
        state={state}
        fechaSeleccionada={fechaSeleccionada}
        díaBloqueado={díaBloqueado}
        onRegistrarArqueo={handleRegistrarArqueo}
        onRegistrarAjuste={handleRegistrarAjustePorArqueo}
        onAnularArqueo={handleAnularArqueo}
      />

      <ModalFondosExternos
        open={modales.esAbierto('FONDOS')}
        onClose={modales.cerrar}
        tipoFondo={tipoFondo}
        setTipoFondo={setTipoFondo}
        montoFondo={montoFondo}
        setMontoFondo={setMontoFondo}
        descripcionFondo={descripcionFondo}
        setDescripcionFondo={setDescripcionFondo}
        metodoPago={metodoPagoFondos}
        setMetodoPago={setMetodoPagoFondos}
        onRegistrar={handleRegistrarFondos}
      />
    </Container>
  );
}